export class Settings {
    public constructor(settings: any) {
        Object.assign(this, settings);
    }
}
export interface Settings {
    base: string;
    url(url: string): string;
    name: string;
    author: string;
    description: string;
    minDate: string;
    mainMenu: Array<{ icon: [string, string]; title: string; to: string; exact: boolean }>;
    errorPages: {
        default: { icon: [string, string]; title: string; message: string; statusCode: number };
        [code: string]: { icon: [string, string]; title: string; message: string; statusCode: number };
    };
    card: string;
    headerLogo: string;
    footerLogo: string;
    LEQ_Logo_Dosage:string;

    programId: string;
    surveyId: string;

    eligibility_ques_3: string;
    eligibility_ques_2: string;
    eligibility_ques_1: string;
    eligibilityFederal: string;
    eligibilityFederalYes: string;
    eligibilityFederalNo: string;
    eligibilityPrescription: string;
    eligibilityPrescriptionYes: string;
    eligibilityPrescriptionNo: string;
    eligibilityCitizen: string;
    eligibilityCitizenAnswerYes: string;
    eligibilityCitizenNo: string;
    eligibilityAge: string;
    eligibilityAgeYes: string;
    eligibilityAgeNo: string;
    eligibilityConsent: string;
    eligibilityConsentYes: string;
    eligibilityConsentNo: string;
    terms: string;
    termsYes: string;
    triangleUp: string;
    triangleDown: string;
    lockEnabled: string;
    lockPassword: string;
    pathQuestion: string;
    sp: string;
    hub: string;
    baseUrl:string;
    ncpdp:string;
    ncpdpAnsID:string;

    programConsentEisaiInfoUseQuestion: string;
    programConsentEisaiInfoUseYes: string;
    programConsentAgeQuestion: string;
    programConsentAgeYes: string;
    programConsentCopayTermsQuestion: string;
    programConsentCopayTermsYes: string;

    patientConfirmQuestionId: string;
    patientConfirmAnswerId: string;
}
